<script lang="ts">
    import { onMount } from 'svelte';
    import Dropdown from '../../../Dropdown.svelte';
    import Button from '../../../Button.svelte';
    import Table from '../../../Table.svelte';
    import Pagination from '../../../Pagination.svelte';

    // Mock data for demonstration
    let auditLogs = [
        { action: 'Processed Payroll', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Success' },
        { action: 'Modified User Permissions', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Failed' },
        { action: 'Generated Tax Report', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Success' },
        { action: 'Modified User Permissions', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Failed' },
        { action: 'Generated Tax Report', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Success' },
        { action: 'Modified User Permissions', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Failed' },
        { action: 'Updated Employee Benefits', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Success' },
        { action: 'Modified User Permissions', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Failed' },
        { action: 'Updated Employee Benefits', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Success' },
        { action: 'Modified User Permissions', admin: 'Michael Chen', timestamp: '12/15/2023 09:30 AM', status: 'Failed' }
    ];

    // Table columns configuration
    const columns = [
        { key: 'action', label: 'Action Taken' },
        { 
            key: 'admin', 
            label: 'Admin Name',
            render: (value: string, row: any) => {
                return `
                    <div class="admin-info">
                        <div class="avatar">${value.charAt(0)}</div>
                        <span>${value}</span>
                    </div>
                `;
            }
        },
        { key: 'timestamp', label: 'Date & Time' },
        { 
            key: 'status',
            label: 'Status',
            align: 'center',
            render: (value: string, row: any) => {
                const statusClass = value.toLowerCase();
                return `
                    <span class="status-badge status-${statusClass}">
                        ${getStatusIcon(value)}
                        <span>${value}</span>
                    </span>
                `;
            }
        }
    ];

    // Filter options
    const employerOptions = [
        { uuid: 'all', name: 'All Employers' },
        { uuid: 'tech', name: 'Tech Solutions Inc.' },
        { uuid: 'future', name: 'Future Enterprises' },
        { uuid: 'global', name: 'Global Children\'s Foundation' },
        { uuid: 'innovation', name: 'Innovation Corp' },
        { uuid: 'ocean', name: 'Ocean Conservation Society' }
    ];
    
    const adminOptions = [
        { uuid: 'all', name: 'All Admins' },
        { uuid: 'michael', name: 'Michael Chen' },
        { uuid: 'sarah', name: 'Sarah Johnson' },
        { uuid: 'david', name: 'David Williams' }
    ];
    
    let selectedEmployer = 'all';
    let selectedAdmin = 'all';
    let startDate = '';
    let endDate = '';
    
    // Pagination
    let currentPage = 1;
    let totalPages = 5;
    
    function applyFilter(): void {
        // In a real implementation, this would filter data based on selected criteria
        console.log('Filtering with:', { selectedEmployer, selectedAdmin, startDate, endDate });
    }
    
    function handlePageChange(event: CustomEvent<{ page: number }>): void {
        currentPage = event.detail.page;
        console.log('Page changed to:', currentPage);
        // Here you would typically load data for the new page
    }

    function getStatusIcon(status: string): string {
        switch(status.toLowerCase()) {
            case 'success': return `
                <svg class="status-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
            `;
            case 'failed': return `
                <svg class="status-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
            `;
            default: return '';
        }
    }
</script>

<div class="audit-log-report-listing-page">
    <div class="filters">
        <div class="filter-item dropdown-wrapper">
            <Dropdown 
                options={employerOptions} 
                selectedValue={selectedEmployer}
                placeholder="All Employers"
            />
        </div>
        <div class="filter-item dropdown-wrapper">
            <Dropdown 
                options={adminOptions} 
                selectedValue={selectedAdmin}
                placeholder="All Admins"
            />
        </div>
        <div class="filter-item date-range-wrapper">
            <label for="audit-start-date" class="filter-label">Start Date</label>
            <input id="audit-start-date" type="date" bind:value={startDate} class="date-input" />
        </div>
        <div class="filter-item date-range-wrapper">
            <label for="audit-end-date" class="filter-label">End Date</label>
            <input id="audit-end-date" type="date" bind:value={endDate} class="date-input" />
        </div>
        <div class="filter-item button-wrapper">
            <Button onClick={applyFilter} primary={true} >Apply Filter</Button>
        </div>
    </div>
    
    <Table 
        title="Audit Log Report"
        columns={columns}
        data={auditLogs}
    />
    
    <div class="pagination-wrapper">
        <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            on:pageChange={handlePageChange}
        />
    </div>
</div>

<style>
    .audit-log-report-listing-page {
        padding: 20px;
        background-color: #f9fafb;
    }
    
    .filters {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 20px;
    }
    
    .button-wrapper {
        width: fit-content !important;
    }   
    
    .dropdown-wrapper :global(.dropdown-container) {
        width: 100% !important;
    }
    
    .date-range-wrapper :global(input) {
        width: 100%;
    }
    
    .button-wrapper {
        display: flex;
        align-items: flex-end;
    }
    
    :global(.status-icon) {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border-radius: 50%;
    }

    :global(.primary) {
        background-color: #000000 !important;
        width: 10% !important;
    }

    /* Apply styles to badges rendered by the Table component */
    :global(.status-badge.status-success), :global(td .status-success), :global(tr .status-success) {
        background-color: #d1fae5 !important;
        color: #065f46 !important;
    }
    
    :global(.status-badge.status-failed), :global(td .status-failed), :global(tr .status-failed) {
        background-color: #fee2e2 !important;
        color: #b91c1c !important;
    }
    
    :global(.status-success .status-icon) {
        color: #10b981 !important;
    }
    
    :global(.status-failed .status-icon) {
        color: #ef4444 !important;
    }

    
    .pagination-wrapper {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    
    /* Responsive styles */
    @media (max-width: 768px) {
        .filters {
            flex-direction: column;
        }
        
        .filter-item {
            width: 100%;
            min-width: unset;
        }
    }
</style>